module.exports = __webpack_public_path__ + "img/b_coin.145c2b3a.png";